import { Injectable } from '@angular/core';
import moment from 'moment';
import { ObservationService } from '../../observation/services/observation.service';
import { DocumentHeapModel, UserLogInActivity, UserLogInActivityDetails } from '../../shared/models/user.model';
import { ConstantsService } from '../../shared/services/constants.service';
import { DataService } from '../../shared/services/data.service';
import { FileAttachment } from '../models/file-attachment.model';
import { LogInInfo } from '../models/user.model';
import { BaseService } from './base.service';


@Injectable()
export class CommonService {
  userLogInActivityDetails: UserLogInActivityDetails;
  documentHeapDetails: DocumentHeapModel;
  userActivityList: UserLogInActivity[];
  userpost: UserLogInActivity;
  userLogInInfo: LogInInfo;
  IpAddress: any;
  login: Date;
  logout: Date;
  constructor(private dataService: DataService,
    private baseService: BaseService, private observationService: ObservationService) {
    this.userLogInActivityDetails = new UserLogInActivityDetails();
    this.userpost = new UserLogInActivity();
    this.userLogInInfo = new LogInInfo();

    const savedIP = this.baseService.getItemFromSession('ipAddress');
    this.IpAddress = savedIP;

    this.documentHeapDetails = new DocumentHeapModel();
  }

  /**
  * Function to get employee details.
  * @param model - Model details.
  * @param successMethod - Function to execute on completion.
  */
  getUser(apiRequest, successMethod) {
    // Get domain details of user
    this.dataService.post(ConstantsService.APIURL.Common.GetUserByEmailOrId, apiRequest)
      .subscribe(response => {
        if (response && response.Success && response.Result) {
          successMethod(response.Result);
        } else {
          this.baseService.processApiResponseError(response);
        }
      });
  }

  /**
   * Function to get status list by process name.
   * @param processName - Process Name.
   * @param successMethod - Funtion to return response.
   */
  getStatusListByProcessName(processNameModel, successMethod) {
    // Get status list by process name
    this.dataService.post(ConstantsService.APIURL.Common.GetStatusListByProcessName
      , processNameModel)
      .subscribe(response => {
        if (response && response.Success && response.Result && !response.Errors) {
          successMethod(response.Result);
        } else {
          this.baseService.processApiResponseError(response);
        }
      });
  }
  /**
       * Function to call to get all the employee's and contractor's name whose initial entered
       * @param processName - Process Name.
       * @param successMethod - Funtion to return response.
       */
  getSearchResultsForUsers(model, callbackMethod) {
    const requestData = model;
    this.dataService.post('api/common/get/usersOnSearch', requestData)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
       * Function to get all user type
       * @param processName - Process Name.
       * @param successMethod - Funtion to return response.
       */
  getUserTypes(callbackMethod) {
    this.dataService.post('api/common/get/userTypes')
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to get all user type
     * @param processName - Process Name.
     * @param successMethod - Funtion to return response.
     */
  getListOfRoleName(callbackMethod) {
    this.dataService.post('api/common/get/listofrolename')
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
      * Function to check if user has particular role
      * @param role - role name.
      */
  isUserHasProvidedRole(role) {
    const loggedInUserJson = JSON.parse(this.baseService.getItemFromSession(ConstantsService.commonConstants.loggedInUser));
    if (loggedInUserJson.UserRoles.length > 0) {
      const userRole = loggedInUserJson.UserRoles.find((item) => item.RoleName === role);
      if (userRole) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  /**
  * Function to get Hse Advsior details by Company id.
  * @param model - Model details.
  * @param successMethod - Function to execute on completion.
  */
  getHseAdvisorDetailsByCompanyId(apiRequest, successMethod) {
    // Get domain details of user
    this.dataService.post(ConstantsService.APIURL.Common.GetHseAdvisorDetailsByCompanyId, apiRequest)
      .subscribe(response => {
        if (response) {
          successMethod(response.Result);
        } else {
          this.baseService.processApiResponseError(response);
        }
      });
  }

  /**
 * Function to Get Company Details
 * @param model - Model contain Status
 * @param callbackMethod - return the response
 */
  getAllCompanyDetails(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetCompanyDetails, model)
      .subscribe(response => {
        callbackMethod(response.Result);
      });
  }

  /**
* Function to Get Company Details
* @param model - Model contain Status
* @param callbackMethod - return the response
*/
  getAppVersion(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Authentication.GetCurrentAppVersion, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getProfileImage(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Authentication.GetProfileImage, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  saveLoggedInUserDetails(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Authentication.SaveLoggedInUserDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  saveUserActivityDetails(sourceId, ActivityDate, ModuleName, UserId, UserLogInActivity) {
    this.userLogInActivityDetails.SourceId = sourceId;
    this.userLogInActivityDetails.ActivityDate = ActivityDate;
    this.userLogInActivityDetails.IpAddress = this.IpAddress;
    this.userLogInActivityDetails.ModuleName = ModuleName;
    this.userLogInActivityDetails.UserId = UserId;
    this.userLogInActivityDetails.UserLogInActivity = UserLogInActivity;
    const apiRequest = {
      Model: this.userLogInActivityDetails
    };
    this.observationService.saveUserLogInDetails(apiRequest, this.callbackMethodForSaveUserActivityDetails.bind(this));
  }
  callbackMethodForSaveUserActivityDetails(response) {
    this.baseService.setItemInSession('UserLogInInformationId', JSON.stringify(response.Result));
  }
  saveUserLogInInfo(logintime, logOutTime, UserId, UserLogInInformationId, IpAddress) {
    this.userLogInInfo.LogInDateTime = logintime;
    this.userLogInInfo.LogOutDateTime = logOutTime;
    this.userLogInInfo.UserId = UserId;
    this.userLogInInfo.IpAddress = IpAddress;
    this.userLogInInfo.UserLogInInformationId = UserLogInInformationId;
    const apiRequest = {
      Model: this.userLogInInfo
    };
    this.saveLoggedInUserDetails(apiRequest, this.callbackMethodForSaveUserActivityDetails.bind(this));
  }
  isDataEqual(oldValue, newValue) {

    if (oldValue instanceof Array) {
      if ((oldValue.length && newValue.length) === 0) {
        return true;
      }
      let E1Array: any = []
      oldValue.forEach((e1) => {
        if (e1 !== 0) {
          E1Array.push(e1);
        }

      })
      E1Array = E1Array.sort((a, b) => a - b);
      let E2Array: any = []
      newValue.forEach((e1) => {
        if (e1 !== 0) {
          E2Array.push(e1);
        }

      })
      E2Array = E2Array.sort((a, b) => a - b);
      let isValid = true;
      if (E1Array.length === E2Array.length) {
        for (let index = 0; index < E1Array.length; index++) {
          if (E1Array[index] !== E2Array[index]) {
            isValid = false;
            break;
          }
        }
      } else {
        isValid = false;
      }

      // E1Array.forEach((e1) => E2Array.forEach((e2) => {
      //     if (e1 === e2) {
      //         isValid = true;
      //     }
      //     else
      //         isValid = false;
      // }));
      return isValid;
    }

    if (newValue instanceof Date) {
      if (moment(moment.utc(oldValue).local()).diff(moment(newValue)) === 0)
        return true;
      else
        return false;
    }
    if (oldValue === newValue) {
      return true;
    } else {
      return false;
    }
  }
  saveDocumentsToHeap(sourceId, companyName, ModuleName, isClosureReport, fileattachments) {
    this.documentHeapDetails.SourceId = sourceId;
    this.documentHeapDetails.CompanyName = companyName;
    this.documentHeapDetails.ModuleName = ModuleName;
    this.documentHeapDetails.IsClosureReportDocument = isClosureReport;
    this.documentHeapDetails.fileAttachments = fileattachments;
    const apiRequest = {
      Model: this.documentHeapDetails
    };
    this.saveDocumentDetailsToHeap(apiRequest, this.callbackMethodForSaveDocumentsToHeap.bind(this));
  }
  callbackMethodForSaveDocumentsToHeap(response) {
  }
  saveDocumentDetailsToHeap(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.SaveDocumentsToDMS, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getPermissionDetailsForUser(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetPermissionDetailsForUser, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  GetUserIndependentPermissions(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetUserIndependentPermissions, model)
      .subscribe(response => {       
        callbackMethod(response);
      });
  }
  getUserIndependentPermissions(UserId) {
    const apiRequest = {
      Model: {
        UserId: UserId
      }
    }
    
    this.GetUserIndependentPermissions(apiRequest, this.callbackMethodForgetUserIndependentPermissions.bind(this));
  }
  GetUserIndependentPermissionsByUserEmail(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetUserIndependentPermissionsByUserEmail, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getUserIndependentPermissionsByUserEmail(Email) {
    const apiRequest = {
      Model: {
        Email: Email
      }
    }
    this.GetUserIndependentPermissionsByUserEmail(apiRequest, this.callbackMethodForgetUserIndependentPermissions.bind(this));
  }
  callbackMethodForgetUserIndependentPermissions(response) {
    if (response) {
      this.baseService.setItemInSession('UserIndependentPermissions', JSON.stringify(response.Result));
    }
  }
  getUsersByUsageType(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetUsersByUsageType, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  confirmPassRequest(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Authentication.ConfirmPassRequest, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  addPobMembers(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Authentication.AddMembers, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getCategoryData(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetCategoryData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getDescriptionListData(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Authentication.GetDescriptionListData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  modifyRecord(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.ModifyRecord, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  restoreRecord(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.RestoreRecord, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  AcceptOrReject(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.ApproveRecord, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  saveSequenceDetails(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.SaveSequenceDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getRecordDetails(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetRecordDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getFAQDetails(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetFAQDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  //BOC Pritesh
  getReportLog(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetReportLog, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getRiskApproverLog(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetRiskApproverLog, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  //EOC Pritesh

}
